// extracted by mini-css-extract-plugin
export var contents = "formbox-module--contents--3961a";
export var field = "formbox-module--field--7d412";
export var footer = "formbox-module--footer--93044";
export var item = "formbox-module--item--1dbbe";
export var label = "formbox-module--label--be46f";
export var required = "formbox-module--required--8368a";
export var root = "formbox-module--root--9978a";
export var title = "formbox-module--title--1a562";